import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e8b68cc")

_pushScopeId("data-v-2e8b68cc")
const _hoisted_1 = { class: "customer_page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 客户360 CID 表链接 ")
const _hoisted_5 = { class: "vid_title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_info = _resolveComponent("info")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_van_button, {
          plain: "",
          icon: "share",
          type: "primary",
          size: "mini",
          onClick: _ctx.jumpToArcher
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_van_button, {
        icon: "replay",
        round: "",
        type: "primary",
        class: 
          _ctx.state.refreshing ? 'refreshBtn animation-rotating' : 'refreshBtn'
        ,
        disabled: _ctx.state.refreshing,
        size: "mini",
        onClick: _ctx.onRefresh
      }, null, 8, ["class", "disabled", "onClick"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createTextVNode(" CID : " + _toDisplayString(_ctx.store.state.CID) + " ", 1),
      _createVNode(_component_van_button, {
        plain: "",
        icon: "exchange",
        type: "primary",
        size: "mini",
        onClick: _ctx.resetCid
      }, null, 8, ["onClick"])
    ]),
    (_ctx.state.loading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          type: "spinner",
          size: "40",
          style: {"margin-top":"40px"}
        }))
      : (_openBlock(), _createBlock(_component_info, {
          key: 1,
          data: _ctx.state.companyInfo || [],
          title: "客户表关键信息"
        }, null, 8, ["data"]))
  ]))
})